import Entity from './entity'
import * as PIXI from 'pixi.js'
import { OutlineFilter as FilterOutline } from '@pixi/filter-outline'
import TWEEN from '@tweenjs/tween.js'
import { lerp } from './utils'

// Represents a player in the game board
class Player extends Entity {
  init (state) {
    this.score = 0
    this._pixi = {}
    const pixiObj = new PIXI.Container()
    // eslint-disable-next-line
    this._pixi.skin = new PIXI.Sprite.fromImage(this.game.config.skins[state.skinId]) // CACHE?
    this._pixi.skin.anchor.set(0.5, 0.5)

    const outline = new FilterOutline(4, state.color + 0x111111)
    this._pixi.skin.filters = [outline]

    pixiObj.addChild(this._pixi.skin)

    const ratio = this._pixi.skin.height / this._pixi.skin.width
    this._pixi.skin.width = 100

    this._pixi.skin.height = this._pixi.skin.width * ratio
    const textObj = new PIXI.Text(state.name, { fill: 0xFFFFaa, stroke: 'black' })
    textObj.anchor.set(0.5, 0.5)
    textObj.alpha = 0.6
    textObj.y = 130
    pixiObj.addChild(textObj)

    const ppos = this.game.renderer.gridToPX(state.pos)
    pixiObj.x = ppos.x
    pixiObj.y = ppos.y
    this.pixiObj = pixiObj
    this.state = state
  }
  destroy () {
    this._pixi.skin.filters = [] // remove filters first
    // this.game.renderer.pixi.players.removeChild(this.pixiObj)
    // DANGEROUS
    this.pixiObj.destroy({ children: true })
    this._pixi = null
  }
  // set
  set (state, isClient) {
    this.state = state

    if (state.id !== this.game.ID) {
      return
    }
    this.animateScore(state.score)

    if (!this.game.config.clientSync) {
      return
    }
    // Specific local case
    if (!isClient) {
      // Append msg to a LIST or override
      // as soon as Timming breaks
      // we jump to the last of the list
      clearTimeout(this.game.sync.player)
      this.game.sync.player = setTimeout(() => {
        const me = this.game.players.playerGet(this.game.ID)
        if (!me) return
        this.set(me.state, true)
      }, this.game.config.syncTimeout)
    }
    this._pos = state.pos
  }
  pos () {
    if (this.id === this.game.ID) {
      return this._pos
    }
    return this.state.pos
  }
  update (delta) {
    let wantPos = this.game.renderer.gridToPX(this.pos())
    let havePos = { x: this.pixiObj.x, y: this.pixiObj.y }
    let curPos = {
      x: lerp(havePos.x, wantPos.x, this.game.config.lerpFactor * delta),
      y: lerp(havePos.y, wantPos.y, this.game.config.lerpFactor * delta)
    }
    this.pixiObj.position.set(curPos.x, curPos.y)
  }
  animateScore (newScore) {
    const scoreDiff = newScore - this.score
    if (scoreDiff <= 0) return
    // Debounce
    // give one second
    this.game.sync.scoreAnim && clearTimeout(this.game.sync.scoreAnim)
    this.game.sync.scoreAnim = setTimeout(() => {
      this.score = this.state.score
      // TODO: Create function for this
      const gr = new PIXI.Text('+' + scoreDiff, {
        fontSize: 40,
        fill: 0xffff99,
        stroke: 'black',
        strokeThickness: 4
      })
      gr.anchor.set(0.5, 0.5)
      const anim = { ...this.game.renderer.gridToPX(this.state.pos), alpha: 1 }
      gr.x = anim.x
      gr.y = anim.y
      // Add score
      // Add the effect to the effect layer
      this.game.renderer.pixi.effects.addChild(gr)
      const dstPos = { y: anim.y - 400, alpha: 0 }
      new TWEEN.Tween(anim)
        .to(dstPos, 2000)
        .onUpdate(() => {
          gr.x += Math.cos(anim.y * 0.1) * 0.2
          gr.y = anim.y
          gr.alpha = anim.alpha
        })
        .onComplete(() => {
          gr.destroy({ children: true, texture: true, baseTexture: true })
        })
        .start()
    }, 400)
  }
}
// Precise method, which guarantees v = v1 when t = 1.
export default Player
